export const getTypeTestUrl = (baseUrl: string) => {
  const typeTestUrl = `${baseUrl}/type16-diagnosis`
  return {
    DIAGNOSIS_TYPE_TEST_QUESTIONS: `${typeTestUrl}`,
    TYPE_TEST_QUESTIONS: `${typeTestUrl}/questions`
  }
}
